import {
  allowedCorsOrigin,
  createContactProxyHandlers,
  enforceRateLimit,
  resetContactProxyRateLimitState,
} from "@lib/contactProxy"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

const contactProxyHandlers = createContactProxyHandlers()

export { allowedCorsOrigin, enforceRateLimit }
export const resetRateLimitState = resetContactProxyRateLimitState

export const Route = createFileRoute("/api/")(
  serverRouteConfig({
    server: {
      handlers: contactProxyHandlers,
    },
  })
)
